import React from "react";
import { Box, Grid, Stack, Typography, Button, Alert } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import InvestorDashboardStats from "./dashboard/InvestorDashboardStats";
import InvestorAssetDistribution from "./dashboard/InvestorAssetDistribution";
import InvestorQuickActions from "./dashboard/InvestorQuickActions";
import { useGetInvestorDashboardQuery } from "../../redux/api/authApi";

const InvestorDashboard = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth?.user);
  const { data: dashRes, isLoading, isError } = useGetInvestorDashboardQuery(undefined, { refetchOnMountOrArgChange: true });
  const welcomeName =
    [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim() ||
    user?.name ||
    (typeof user?.email === "string" ? user.email.split("@")[0] : "") ||
    "there";

  const dashData = dashRes?.data ?? {};
  const summary = dashData.summary ?? {};
  const assetDistribution = dashData.assetDistribution ?? [];

  return (
    <Box>
      {/* Header */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={2}
        sx={{ mb: 3 }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 1.5,
              bgcolor: "background.headerIcon",
              border: (theme) => `1px solid ${theme.palette.border.light}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <BarChartOutlinedIcon sx={{ color: "text.slate", fontSize: 28 }} />
          </Box>
          <Box>
            <Typography
              variant="h5"
              fontWeight={700}
              sx={{ color: "text.primary", letterSpacing: -0.5 }}
            >
              Portfolio Dashboard
            </Typography>
            <Typography variant="body2" sx={{ color: "text.muted", mt: 0.5 }}>
              Welcome back, {welcomeName} - Track your investments
            </Typography>
          </Box>
        </Stack>
        <Button
          variant="contained"
          sx={{
            textTransform: "none",
            fontWeight: 700,
            color: "common.white",
            background: (theme) => theme.palette.gradients.teal,
            borderRadius: 1.25,
            px: 2.5,
            py: 1.1,
            "&:hover": {
              background: (theme) => theme.palette.gradients.tealHover,
            },
          }}
          onClick={() => navigate("/investor/viewinvest")}
        >
          Discover Assets
        </Button>
      </Stack>

      {isError && (
        <Alert severity="error" sx={{ mb: 3 }}>
          Could not load dashboard data.
        </Alert>
      )}

      {/* Stats */}
      <InvestorDashboardStats summary={summary} isLoading={isLoading} />

      {/* Charts row */}
      <Grid container spacing={3} sx={{ mt: 0, mb: 3 }}>
        {/* <Grid size={{ xs: 12, md: 8 }}>
          <InvestorPortfolioGrowth />
        </Grid> */}
        <Grid size={{ xs: 12, md: 12 }}>
          <InvestorAssetDistribution distribution={assetDistribution} isLoading={isLoading} />
        </Grid>
      </Grid>

      {/* Income vs Expenses (full width) */}
      {/* <Box sx={{ mt: 3 }}>
        <InvestorIncomeVsExpenses />
      </Box> */}

      {/* Quick Actions + Alerts */}
      <Grid container spacing={3} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, md: 12 }}>
          <InvestorQuickActions />
        </Grid>
        {/* <Grid size={{ xs: 12, md: 6 }}>
          <InvestorAlerts />
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default InvestorDashboard;
